export const common =  {
    '请求延时': 'Задержка запроса',
    '操作成功': 'Операция выполнена успешно',
    '暂无数据': 'Нет данных',
    '请输入': 'Пожалуйста, введите',
    'copyok': 'Скопировано успешно',
    'copyerror': 'Ошибка копирования',
  };

 export const tableList = {
    '持仓': 'Позиции',
    '仓位': 'Позиция',
    '跟单交易量':'Объём копитрейдинга',
    '跟单总交易量':'Общий объём копитрейдинга',
    '用户昵称':'Никнейм пользователя',
    '当前委托': 'Активные ордера',
    '当前计划': 'Плановые ордера',
    '历史仓位': 'История позиций',
    '账单': 'Финансовые записи',
    '全部平仓': 'Закрыть все позиции',
    '全部撤单': 'Отменить все ордера',

    '合约名称': 'Название контракта',
    '创建时间': 'Время создания',
    '方向': 'Направление',
    '杠杆': 'Плечо',
    '保证金': 'Маржа',
    '开仓价格': 'Цена открытия',
    '开仓均价': 'Средняя цена открытия',
    '全仓风险率': 'Коэффициент риска (Cross)',
    '预估爆仓价': 'Расчётная цена ликвидации',
    '收益率': 'Доходность',
    '平仓价格': 'Цена закрытия',
    '预计强平价': 'Расчётная принудительная цена',
    '持仓数量': 'Размер позиции',
    '张': 'контрактов',
    风险率: 'Коэффициент риска',
    保证金率: 'Уровень маржи',
    预计止盈价: 'Расчётная цена тейк-профита',
    预计止损价: 'Расчётная цена стоп-лосса',
    浮动盈亏: 'Плавающий P&L',
    平仓盈亏: 'P&L при закрытии',
    盈亏: 'P&L',
    委托数量: 'Объём ордера',
    委托价格: 'Цена ордера',
    成交价格: 'Цена исполнения',
    成交均价: 'Средняя цена исполнения',
    止盈价: 'Цена тейк-профита',
    止损价: 'Цена стоп-лосса',
    执行价: 'Цена исполнения',
    触发条件: 'Условие триггера',
    操作: 'Действие',
    手续费: 'Комиссия',
    平仓类型: 'Тип закрытия',
    类型: 'Тип',
    数量: 'Количество',

    逐仓做多: 'Isolated Long',
    逐仓做空: 'Isolated Short',
    全仓做多: 'Cross Long',
    全仓做空: 'Cross Short',
    永续合约: 'Бессрочный контракт',

    手动平仓: 'Ручное закрытие',
    市价平仓: 'Закрытие по рыночной цене',
    限价平仓: 'Закрытие по лимитной цене',
    止盈: 'Тейк-профит',
    止损: 'Стоп-лосс',
    手动撤销: 'Ручная отмена',
    自动减仓: 'Автоуменьшение позиции',
    强制减仓: 'Принудительное уменьшение',
    强制平仓: 'Принудительная ликвидация',
    资金不足系统撤单: 'Отмена системой из-за недостатка средств',
    资金超限系统撤单: 'Отмена системой из-за превышения лимита средств',
    撤单: 'Отменить ордер',
    平仓: 'Закрыть позицию',
    更多: 'Ещё',
    部分平仓: 'Частичное закрытие',
    反向开仓: 'Открытие в противоположную сторону',
    加仓: 'Добавить к позиции',
    一键平仓: 'Закрыть всё',
    最新价: 'Последняя цена',
    体验金平仓: 'Закрытие по истечении 24 часов',
    下单时间: 'Время ордера',
    交易类型: 'Тип сделки',
    委托类型: 'Тип ордера',
    成交类型: 'Тип исполнения',
    逐仓平多: 'Isolated закрытие Long',
    逐仓开多: 'Isolated открытие Long',
    逐仓平空: 'Isolated закрытие Short',
    逐仓开空: 'Isolated открытие Short',
    全仓平多: 'Cross закрытие Long',
    全仓开多: 'Cross открытие Long',
    全仓平空: 'Cross закрытие Short',
    全仓开空: 'Cross открытие Short',
    可平量为0: 'Доступно для закрытия: 0',
    激活价格: 'Цена активации',
    状态: 'Статус',
    未激活: 'Не активирован',
    已激活: 'Активирован',
    回调率: 'Процент отката',
    仓位ID: 'ID позиции',
  };
  
  export const dialog = {
    前往设置: 'Перейти в настройки',
    提示: 'Внимание',
    确定: 'Подтвердить',
    取消: 'Отмена',
    确认要全部平仓吗: 'Подтвердите закрытие всех позиций по рыночной цене и отмену всех ордеров?',
    确认要全部撤单吗: 'Подтвердите отмену всех ордеров?',
    确认要一键平仓吗: 'Подтвердите закрытие всех позиций?',
    确认要一键平仓: 'Подтвердить закрытие всех позиций и прекращение копитрейдинга?',
    确认要市价平仓吗: 'Подтвердить закрытие по рыночной цене?',
    确认要限价平仓吗: 'Подтвердить закрытие по лимитной цене?',
    需先设置总跟单账户:"Сначала настройте основной счёт для копитрейдинга",
    加仓: 'Добавить к позиции',
    不能为空: 'Не может быть пустым',
    必须为数字值: 'Должно быть числом',
    数字不能小于等于0: 'Число не может быть ≤0',
    请输入正确的杠杆倍数: 'Введите корректное значение плеча',
    无法切换仓位模式: 'Невозможно изменить режим позиции',
    当前账户没有权限: 'У вас нет прав',
    swap001: 'Невозможно изменить режим позиции при открытой позиции',
    需全部平仓后可重新设置:"При наличии позиций копитрейдинга невозможно изменить сумму и коэффициент копирования. Закройте все позиции и повторите попытку.",
    按张数: 'По контрактам',
    按金额: 'По сумме',
    按比例: 'По проценту',
    按价格: 'По цене',
    张: 'контрактов',
    预计加仓金额: 'Расчётная сумма добавления',
    预计加仓张数: 'Расчётное количество контрактов',
    持仓数量: 'Размер позиции',
    开仓价格: 'Цена открытия',
    确认要反向开仓吗: 'Подтвердить открытие в противоположную сторону?',
    预计平仓金额: 'Расчётная сумма закрытия',
    预计平仓比例: 'Расчётный процент закрытия',
    预计平仓张数: 'Расчётное количество контрактов при закрытии',
    比例不可以大于: 'Процент не может превышать',
    比例不可以小于: 'Процент не может быть меньше',
    部分平仓: 'Частичное закрытие',
    确认撤单吗: 'Подтвердить отмену ордера?',
    确认要平仓吗: 'Подтвердить закрытие позиции?',
    盈亏: 'P&L',
    当前止损价: 'Текущая цена стоп-лосса',
    预估止损价: 'Расчётная цена стоп-лосса',
    亏损: 'Убыток',
    止损修改: 'Изменить стоп-лосс',
    止损比例: 'Процент стоп-лосса',
    止损价格: 'Цена стоп-лосса',
    当前盈利价: 'Текущая цена тейк-профита',
    预估止盈价: 'Расчётная цена тейк-профита',
    收益: 'Прибыль',
    止盈修改: 'Изменить тейк-профит',
    止盈比例: 'Процент тейк-профита',
    止盈价格: 'Цена тейк-профита',
    请输入加仓数: 'Введите количество контрактов для добавления',
    请输入金额: 'Введите сумму',
    请输入止盈价格: 'Введите цену тейк-профита',
    请输入止盈比例: 'Введите процент тейк-профита',
    请输入止损价格: 'Введите цену стоп-лосса',
    请输入止损比例: 'Введите процент стоп-лосса',

    'BTC/USDT账户模式': 'Режим счёта BTC/USDT',
    账户模式: 'Режим счёта',
    调整仓位模式: 'Изменить режим позиции',
    保证金模式: 'Режим маржи',
    仓位模式: 'Режим позиции',
    调整保证金模式: 'Изменение режима маржи применимо ко всем контрактам USDT',
    调整仓位合并模式: 'Изменение режима объединения позиций применимо ко всем контрактам USDT',
    全仓模式: 'Режим Cross',
    仓位合并: 'Объединение позиций',
    逐仓: 'Isolated',
    全仓: 'Cross',
    合仓: 'Объединённая позиция (One-way)',
    分仓: 'Раздельная позиция (Hedge)',
    swap002:
      'В режиме Isolated пользователь может иметь как длинную, так и короткую позиции с независимым расчётом риска. При ликвидации теряется только маржа позиции. При ручном закрытии прибыль/убыток по каждой позиции немедленно зачисляется в её маржу.',
    全仓模式下所有仓位将共享合约账户的可用保证金: 'В режиме Cross все позиции используют доступную маржу фьючерсного счёта. При принудительной ликвидации вы можете потерять все позиции и доступную маржу. Учитывайте риск!',
    合仓提示: '',
    分仓提示: '',
    不再提示: 'Больше не показывать',

    biking合约用户使用协议: 'Пользовательское соглашение по фьючерсам Biking',
    综述:
      '<b>1. Общие положения</b><br><br>' +
      '<span>' +
      '1.1 Бессрочный контракт («Услуга») — это цифровой дериватив, предлагаемый Biking. Biking отвечает за разработку продукта и операционную поддержку торговой платформы. ' +
      'Используя бессрочный контракт Biking, вы соглашаетесь соблюдать настоящее Соглашение. Пожалуйста, внимательно прочитайте все условия.' +
      '<br><br>' +
      '1.2 Если вы не принимаете условия, вы не имеете права использовать услугу. Использование услуги означает ваше согласие с Соглашением.' +
      '</span>' +
      '<br><br>' +
      '<b>2. Право на использование услуги</b>' +
      '<br><br>' +
      '<span>2.1 Вы подтверждаете:' +
      '<br>' +
      '• Вы согласны с Условиями обслуживания Biking и имеете право их использовать;' +
      '<br>' +
      '• Соглашение не противоречит законам вашей страны;' +
      '<br>' +
      '• Вы являетесь законным владельцем депонируемых активов.' +
      '<br><br>' +
      '2.2 Вы понимаете риски, включая:' +
      '<br>' +
      '• Высокая волатильность цифровых активов может привести к быстрым потерям.' +
      '</span>',
    我已阅读并同意上述协议: 'Я прочитал и соглашаюсь с Соглашением',

    调整杠杆: 'Смена плеча',
    杠杆倍数: 'Плечо',
    当前杠杆倍数最大可开: 'Максимально возможный размер при текущем плече:',
    '当前仓位所需保证金：': 'Необходимая маржа для текущей позиции:',

    交易单位切换: 'Смена единиц торговли',
    成交类型切换: 'Выбор типа исполнения',
    限价: 'Лимитный',
    市价: 'Рыночный',
    数字范围必须在: 'Число должно быть в диапазоне от 1 до 100',
    请输入平仓数: 'Введите количество для закрытия',
    请输入平仓比例: 'Введите процент закрытия',
    请输入整数: 'Введите целое число',
    以当前最优价格交易: 'Торговать по лучшей доступной цене',
    请输入格式正确的杠杆倍数: 'Введите корректное плечо',
    杠杆倍数提示: 'Высокое плечо увеличивает риск.',
    下单二次确认: 'Подтверждение ордера',
    平仓二次确认: 'Подтверждение закрытия',
    下单确认: 'Подтвердить ордер',
    二次确认不展示: 'Больше не показывать (можно включить заново в настройках)',
    切换交易单位: 'Сменить единицу',
    偏好设置: 'Настройки',
    仓位止盈止损: 'TP/SL для позиции',
    移动止盈止损: 'Трейлинг-стоп (TP/SL)',
    止盈止损提示:
      'Трейлинг-стоп используется для автоматического закрытия при движении цены в благоприятную сторону и последующем откате. При достижении цены активации ордер активируется, а при откате на заданную величину от максимума/минимума ордер исполняется.',
    最新成交价: 'Последняя цена исполнения',
    设置止盈: 'Установить TP',
    设置止损: 'Установить SL',
    预计盈利: 'Расчётная прибыль',
    预计亏损: 'Расчётный убыток',
    调整保证金: 'Изменить маржу',
    增加: 'Увеличить',
    减少: 'Уменьшить',
    最大: 'Максимум',
    当前仓位保证金: 'Текущая маржа позиции',
    最大可增加: 'Максимум увеличения',
    最大可减少: 'Максимум уменьшения',
    调整后参考强评价: 'Расчётная цена ликвидации после изменения',
    请输入保证金: 'Введите маржу',
    强平价格: 'Цена ликвидации',
    开仓数量: 'Размер открытия',
    计算: 'Рассчитать',
    计算结果: 'Результат расчёта (справочно)',
    回调率: 'Откат',
    请输入回调率: 'Введите откат',
    仓位数量: 'Размер позиции',
    激活价: 'Цена активации',
    请输入激活价: 'Введите цену активации',
    激活做多提示: 'Для Long цена активации должна быть выше последней цены',
    激活做空提示: 'Для Short цена активации должна быть ниже последней цены',
  };
  
  export const codeInfo = {
    永续合约: 'Бессрочный',
    标记价格: 'Марк-цена',
    指数价格: 'Индексная цена',
    指数价格提示:
      'Текущая индексная цена контракта. Участвует в расчёте ликвидации, может отличаться от последней цены для предотвращения манипуляций.',
    '24H最高': '24h максимум',
    '24H最低': '24h минимум',
    资金费率: 'Текущая ставка финансирования',
    距费用结算: 'До следующей выплаты ставки финансирования',
    我的赠金: 'Мои бонусы',
  };
  
  export const panKou = {
    交易深度: 'Стакан',
    实时成交: 'Сделки',
    张: 'контрактов',
    保证金: 'Маржа',
    价格: 'Цена',
    数量: 'Количество',
    时间: 'Время',
    累计: 'Накоплено',
  };
  
  export const placeOrder = {
    立即去玩:"Играть сейчас",
    全仓: 'Cross',
    逐仓: 'Isolated',
    杠杆: 'Плечо',
    开多: 'Long',
    开空: 'Short',
    市价委托: 'Рыночная',
    限价委托: 'Лимитная',
    计划委托: 'Условная',
    价格: 'Цена',
    数量: 'Количество',
    限价: 'Лимитная',
    市价: 'Рыночная',
    止盈止损: 'TP/SL',
    张: 'контрактов',
    开仓价: 'Цена открытия',
    触发价: 'Триггер',
    执行价: 'Цена исполнения',

    收益: 'Прибыль',
    按比例设置: 'По проценту',
    按价格设置: 'По цене',
    亏损: 'Убыток',

    swap003: 'Купить / Long',
    swap004: 'Продать / Short',
    买入: 'Купить',
    卖出: 'Продать',
    做多: 'Long',
    做空: 'Short',
    可用: 'Доступно',
    可做多: 'Доступно для Long',
    可做空: 'Доступно для Short',

    资产: 'Активы',
    持仓保证金: 'Маржа позиций',
    未实现盈亏: 'Нереализованный P&L',
    净值: 'Стоимость портфеля',
    可用保证金: 'Доступная маржа',
    账户余额: 'Баланс счёта',
    风险率: 'Коэффициент риска',

    合约信息: 'Информация о контракте',
    指数来源: 'Источник индекса',
    合约面值: 'Номинал контракта',
    资金费率: 'Ставка финансирования',
    最大杠杆: 'Макс. плечо',
    下单方向可开张数的: 'Максимальный размер при данном направлении',

    立即注册: 'Зарегистрироваться',
    登录: 'Войти',
    swap005: 'Активы (бессрочный контракт)',
    登录以查看: 'Войдите, чтобы увидеть',

    请输入数量: 'Введите количество',
    请输入价格: 'Введите цену',
    请输入限价: 'Введите лимитную цену',
    请输入止盈止损: 'Введите TP/SL',
    '止损率不能大于90%': 'Процент SL не может превышать 90%',
    止损价格不能大于: 'Цена SL не может превышать',
    开通合约账号: 'Активировать фьючерсный счёт',
    账号冻结: 'Счёт заморожен',
    '止盈率不能大于1000%': 'Процент TP не может превышать 1000%',
    请输入触发价: 'Введите цену триггера',
    保证金: 'Маржа',
    体验金: 'Бонусные средства',
    不使用体验金: 'Не использовать бонус',
    查看详情: 'Подробнее',
    委托保证金: 'Маржа под ордерами',
    币: 'Монета',
    计算器: 'Калькулятор',
    划转: 'Перевести'
  };
  
  export const codelist = {
    搜索: 'Поиск',
    全部: 'Все',
    交易对: 'Торговая пара',
    最新价: 'Последняя цена',
    涨幅: 'Изменение',
    自选: 'Избранное',
    添加自选成功: 'Добавлено в избранное',
    取消自选成功: 'Удалено из избранного',
  };
  
  export const merchandiser = {
    我的实盘: "Мои реальные сделки",
    与优秀的交易员共同赚钱:"Зарабатывайте вместе с лучшими трейдерами",
    code_00051: "Копитрейдинг",
    个人中心:'Личный кабинет',
    更多服务:'Больше услуг',
    钱包: "Кошелёк",
    衍生品:'Деривативы',
    跟单设置:'Настройки копирования',
    跟单: 'Копировать',
    跟单提示: 'Данные обновляются каждый час',
    我的跟单: 'Мои копируемые сделки',
    成为交易员: 'Стать ведущим трейдером',
    综合排名: 'Общий рейтинг',
    收益率: 'Доходность',
    近3周收益: 'Прибыль за 3 недели',
    近3周胜率: 'Процент прибыльных сделок за 3 недели',
    总收益: 'Общая прибыль',
    累计收益率: 'Совокупная доходность',
    累计跟随人数: 'Всего копировавших',
    跟随中: 'Копируют сейчас',
    AUM: 'AUM (активы под управлением)',
    当前跟谁: 'Сейчас копируют',
    搜索交易员: 'Поиск трейдера',
    满员: 'Мест нет',
    申请成为交易员: 'Стать ведущим',
    手机号: 'Телефон',
    邮箱: 'Email',
    请输入邮箱: 'Введите email',
    邮箱错误: 'Неверный email',
    请输入手机号: 'Введите телефон',
    手机号错误: 'Неверный номер',
    请输入正确数值: 'Введите корректную сумму',
    申请交易员提示文案: 'Станьте ведущим и получайте долю от прибыли',
    跟单确认: 'Подтверждение копирования',
    我已同意跟单协议: 'Я прочитал и согласен с Условиями копитрейдинга',
    跟单协议: 'Условия копитрейдинга',
    申请跟单提示文案: "Настоящее Соглашение заключается между вами и BiKing. Используя сервис, вы подтверждаете, что прочитали, поняли и приняли все условия.",
    申请跟单提示文案1: "1. Копирование сделок может привести к убыткам. Риск полностью ложится на копирующего.",
    申请跟单提示文案2: "2. Поддерживается копирование на Isolated счёт. Для самостоятельной торговли используйте стандартный фьючерсный счёт.",
    申请跟单提示文案3: "3. Копируются только новые ордера ведущего. Вы можете отменить копирование в любой момент; открытые позиции не закроются автоматически.",
    申请跟单提示文案4: "4. Ручное изменение скопированной позиции приведёт к отвязке от ведущего.",
    申请跟单提示文案5: "5. При получении прибыли по скопированному ордеру 12% прибыли удерживается в пользу ведущего трейдера.",
    申请跟单提示文案6: "6. Высокий риск. Копируйте осознанно. Ознакомьтесь с правилами.",
    申请跟单提示文案7: "7. Если ведущий удаляется за нарушения, новые сделки не копируются, но открытые позиции остаются (без дальнейшего копирования).",
    申请跟单提示文案8: "8. Ведущий может удалить копирующего. После этого новые ордера ведомого не копируются, открытые позиции остаются.",
    搜索您的国家名或国家区号: 'Поиск по названию страны или коду',
    我已同意成为交易员: 'Я согласен стать ведущим',
    请勾选: 'Отметьте галочку',
    申请交易员失败提示: 'Вы сейчас копируете сделки. Сначала отмените копирование.',
    我知道了: 'Понятно',
    今日收益: 'Прибыль за сегодня',
    累计收益: 'Общая прибыль',
    交易员分成: 'Доля ведущего',
    待结算分成: 'Доля к расчёту',
    已结算分成: 'Выплаченная доля',
    当前跟单: 'Активные копии',
    历史跟单: 'История копий',
    我的交易员: 'Мои ведущие',
    编辑: 'Редактировать',
    平仓均价: 'Средняя цена закрытия',
    持仓均价: 'Средняя цена открытия',
    开仓时间: 'Время открытия',
    平仓时间: 'Время закрытия',
    预估暴仓价: 'Расчётная цена ликвидации',
    交易员: 'Ведущий трейдер',
    详情: 'Детали',
    仓位ID: 'ID позиции',
    空位提醒: 'Уведомление о месте',
    空位提醒内容: 'У этого ведущего закончились места. Отправить уведомление, когда появится свободное место?',
    当前跟随: 'Текущее копирование',
    跟随人数数据: '{v1}/{v2} чел.',
    跟随人数: 'Копируют',
    总权益: 'Общий капитал',
    带单合约: 'Копируемый контракт',
    交易数据: 'Данные сделок',
    交易笔数: 'Сделок',
    盈利笔数: 'Прибыльных',
    亏损笔数: 'Убыточных',
    扛单比例: 'Позиции удержания',
    平均扛单率: 'Ср. % удержания',
    最大扛单率: 'Макс. % удержания',
    订单: 'Ордер',
    跟随者: 'Копирующий',
    跟随者收益: 'Прибыль копирующего',
    跟随用户: 'Пользователь',
    跟随总额: 'Общая сумма копирования',
    跟随收益: 'Прибыль от копирования',
    交易员订单本金: 'Собственные средства ведущего',
    当前带单: 'Активные копируемые сделки',
    历史带单: 'История копируемых сделок',
    跟单数据统计: 'Статистика копитрейдинга',
    不用了: 'Не надо',
    设置提醒成功: 'Уведомление настроено',
    我的带单: 'Мои копируемые сделки',
    查看主页: 'Профиль',
    利润分成比例: 'Процент от прибыли',
    跟随交易员: 'Копировать трейдера',
    仓位类型: 'Тип позиции',
    指定杠杆: 'Плечо',
    请输入杠杆: 'Введите плечо',
    单笔倍率: 'Коэффициент копирования',
    单笔金额: 'Фиксированная сумма',
    固定额度: 'Фикс. сумма',
    请输入单笔金额1: 'Введите фикс. сумму не менее 5 USDT',
    请输入单笔金额: 'Введите сумму копирования на сделку {v1}–{v2}',
    请输入单笔倍率: 'Введите коэффициент копирования {v1}–{v2}',
    每次下单折合U: 'Открытие сделки эквивалентно марже {v1} USDT',
    每次下单倍数: 'Объём сделки = объём ведущего × {v1}',
    倍率: 'Коэффициент',
    跟单本金: 'Бюджет копирования',
    总跟单保证金: 'Общая маржа копирования',
    请输入跟单本金: 'Введите бюджет копирования',
    资产账户: 'Аккаунт активов {v1} USDT',
    合约账户: 'Фьючерсный счёт {v1} USDT',
    风险控制: 'Контроль риска',
    设置: 'Настройки',
    保存: 'Сохранить',
    取消跟随: 'Отменить копирование',
    移除跟随: 'Удалить копирующего',
    交易员保证金: 'Маржа ведущего',
    请输入交易员保证金: 'Введите маржу ведущего',
    风险设置提示: 'При достижении порога открытие новых сделок прекращается.',
    关闭带单: 'Выключить режим ведущего',
    我的跟随者: 'Мои копирующие',
    带单设置: 'Настройки ведущего',
    预计利润分成: 'Расчётная доля прибыли',
    利润分成: 'Доля прибыли',
    开启成功: 'Включено',
    开启失败: 'Ошибка',
    关闭成功: 'Выключено',
    关闭失败: 'Ошибка',
    确认取消吗: 'Отменить копирование?',
    条件一: 'Нет открытых позиций, активных и плановых ордеров',
    条件二: 'Доступный баланс фьючерсного счёта ≥ {v} USDT',
    条件三: 'Нет позиций',
    最大回撤: 'Макс. просадка',
    平均持仓时间: 'Среднее время удержания',
    正在跟随: 'Копирую',
    历史跟随: 'История копирования',
    累计跟单: 'Всего скопировано',
    累计分成: 'Всего выплачено доли',
    笔: 'сделок',
    上一页: 'Назад',
    下一页: 'Вперёд',
    返回: 'Назад',
    今日预估收益: 'Расчётная прибыль за сегодня',
    账户权益: 'Капитал счёта',
    将账户权益展示在个人信息页面: 'Показывать капитал счёта в профиле',
    带单本金: 'Собственные средства ведущего',
    每次开仓均会展示带单本金: 'Показывать собственные средства при открытии',
    隐藏挂单价:'Скрывать цену ордера',
    带单币对: 'Пары ведущего',
    入住时间: 'Дата регистрации',
    保存成功: 'Сохранено',
    取消成功: 'Отменено',
    设置成功: 'Настроено',
    跟单合约: 'Копируемый контракт',
    历史委托: 'История ордеров',
    成交数量: 'Исполнено',
    触发时间: 'Время срабатывания',
    开启带单: 'Стать ведущим',
    账户已冻结: 'Счёт заморожен, свяжитесь с поддержкой',
    审核中: 'На рассмотрении',
    小时: '{v} ч.',
    累计分润: 'Всего выплачено',
    今日预估分润: 'Расчётная доля за сегодня',
    交易协议: 'Торговое соглашение',
    带单协议: 'Соглашение ведущего',
    追加跟单本金: 'Пополнить бюджет копирования',
    提示: 'Внимание:',
    提示信息: 'Расчёт доли происходит ежедневно в 00:00, зачисление до 01:00. При наличии позиций выплата переносится на следующий день.',
    合约跟单: 'Копитрейдинг',
    跟单文字: 'Зарабатывайте с топ-трейдерами на Biking',
    查看牛人实盘: 'Смотреть профили лучших',
    捕捉市场信号: 'Ловите сигналы рынка',
    复制高手收益: 'Копируйте доходы профессионалов',
    跟单指南: 'Инструкция по копированию',
    跟单广场: 'Сообщество трейдеров',
    跟单总收益: 'Общий доход трейдеров (копирующих)',
    丰厚分润收入: 'Высокий процент от прибыли',
    更多平台曝光: 'Продвижение на платформе',
    专属交易徽章: 'Эксклюзивный бейдж',
    成为Biking带单交易员: 'Один шаг до статуса ведущего на Biking',
    享受Biking带单交易员的独家福利: 'Привилегии для ведущих Biking:',
    平台奖励: '12% комиссии с прибыли копирующих',
    联系方式: 'Контакты',
    简介: 'О себе',
    请输入简介: 'Расскажите о себе',
    交易能力证明: 'Подтверждение квалификации (опционально)',
    选择周期: 'Приложите график доходности за >30 дней и статистику. Если не приложите, мы проверим историю на других биржах. Можно загрузить до 3 файлов, каждый до 10 МБ.',
    我已阅读并同意: 'Я прочитал и принимаю',
    跟单交易服务条款: 'Условия копитрейдинга',
    立即申请: 'Подать заявку',
    请输入联系方式: 'Введите контакты',
    联系方式不正确: 'Контакты указаны неверно!',
    邮箱格式不正确: 'Неверный формат email',
    请输入简介信息: 'Заполните описание',
    请确认勾选协议: 'Примите условия',
    上传头像图片限制: 'Размер аватара не должен превышать 10 МБ!',
    最大限制: 'Максимум 3 файла',
    带单交易员招募中: 'Набор ведущих трейдеров: до 12% от прибыли',
    跟单成功: 'Копирование началось',
    昵称: 'Никнейм',
    请输入昵称: 'Введите никнейм',
    申请交易员已提交: 'Заявка подана, ожидайте проверки'
  };
  
  export const hyy = {
    bkt: "Не открывать",
    wqdkt: "Открыть",
    kt12: "1. Прежде чем участвовать, вы должны детально изучить основы и риски торговли контрактами, а также правила платформы.",
    kt13: "2. Данный список рисков не является исчерпывающим. Дополнительно оцените иные возможные риски.",
    kt14: "3. Мы рекомендуем вам оценить свою устойчивость к риску и принять взвешенное решение о торговле.",
    kt0: "Уважаемый пользователь:",
    kt1: "У вас ещё нет фьючерсного счёта. Пожалуйста, внимательно прочитайте следующее перед открытием:",
    kt2: "1. При недостатке маржи может произойти принудительная ликвидация позиции BiKing.",
    kt3: "2. Вы должны изучить правила и механизмы работы бессрочных контрактов BiKing.",
    kt4: "3. Позиции переоцениваются в зависимости от рынка. При значительном убытке может произойти ликвидация. Вы несёте ответственность за свои сделки.",
    kt5: "4. В экстремальных рыночных условиях закрытие позиции может быть затруднено (например, при лидерстве по P&L и недостаточности страхового фонда).",
    kt6: "5. Существуют регуляторные риски. Изучите законодательство своей юрисдикции. Возможны изменения правил.",
    kt7: "6. Неплатформенные риски (форс-мажор, сбои связи) могут повлиять на исполнение ордеров.",
    kt8: "7. Хеджирование также сопряжено с ценовыми рисками.",
    kta9: "8. Отсутствие верификации или передачи аккаунта может повлиять на безопасность маржи.",
    kta10: "2. В экстремальных рыночных условиях (например, при лидерстве по P&L и недостатке страхового фонда) закрытие позиции может быть недоступно.",
    kt9: "Я внимательно прочитал и принимаю риски",
    kt10: "Активировать фьючерсный счёт",
    zjhz: "Перевод средств",
    ljhz: "Перевести",
    qx: "Отмена",
    khz: "Доступно для перевода",
    qxz: "Выберите",
    bz: "Монета",
    c: "С",
    zz: "На",
    sl: "Количество",
    qb: "Всё",
    ktcg: "Активация успешна",
    ktsb: "Ошибка активации",
    hzcg: "Перевод успешен",
    hzsb: "Ошибка перевода",
    wyyd: "", // не заполнено предупреждение о прочтении
    tc: "Выйти",
    warning1: "Выберите монету",
    warning2: "Счёт отправления не может быть пустым",
    warning3: "Счёт назначения не может быть пустым",
    warning4: "Введите сумму не более доступной",
    gb: "Закрыть",
    openSuccess: "Фьючерсный счёт активирован",
    openSuccessTip: "Переведите средства на фьючерсный счёт",
    warning5: "Максимум 4 знака после запятой",
    not_get_nm: "К сожалению, акция с бонусами завершена, при переводе бонус не начислен.",
  }

  export const invite = {
    yqfy: "Реферальная программа",
    yj1: "Поделитесь реферальной ссылкой, постером или кодом",
    yj2: "Пригласите друзей зарегистрироваться и торговать",
    yj3: "Получайте комиссию с их сделок",
    yqm: "Мой реферальный код:",
    yqlj: "Моя реферальная ссылка:",
    fz: "Копировать",
    fzcg: "Скопировано",
    fzsb: "Ошибка копирования",
    dlck: "Войдите для просмотра",
    rs: "Приглашено",
    ljbb: "Всего возврата за спот ({flag})",
    ljeft: "Всего возврата за ETF ({flag})",
    ljhy: "Всего возврата за фьючерсы ({flag})",
    yhm: "Пользователь",
    sfsm: "Верифицирован",
    tjsj: "Дата приглашения",
    zsy: "Общий доход ({flag})",
    s: "Да",
    f: "Нет",
    djjz: "Загрузить ещё",
    ckmx: "Подробнее",
    pm: "Рейтинг",
    zyqr: "Приглашений в этом месяце",
    zfyj: "Возврат за месяц ({flag})",
    ckbd: "Весь рейтинг",
    rlues1: "Приглашайте друзей, получайте комиссию без ограничений.",
    rlues2: "Связь устанавливается при регистрации по вашему коду. Возврат за спот и ETF — бессрочно.",
    rlues3: "Правила и проценты возврата",
    jylx: "Тип сделки",
    yqrfy: "Возврат пригласившему",
    yqgxyxq: "Срок действия реферальной связи",
    sixMonth: "6 месяцев",
    yj: "Бессрочно",
    bbjy: "Спот",
    hyjy: "Фьючерсы",
    etfjy: "ETF",
    gxsj: "Данные обновляются по понедельникам",
    xts: "Совет",
    ts1: "Друг должен указать ваш код при регистрации!",
    ts2: "Отсканируйте QR-код или поделитесь ссылкой, чтобы быстро пригласить.",
    tgzsy: "Общий доход от рефералов ({flag})",
    cz: "Действие",
    fymx: "Детали возврата >",
    zwsj: "Нет записей",
    yh: "Пользователь",
    hqyj: "Получено возврата",
    ysm: "Верифицирован",
    wsm: "Не верифицирован",
    hyfymx: "Детали возврата по друзьям",
    fylx: "Тип возврата",
    fyje: "Сумма возврата",
    fysj: "Время возврата",
    mxsyb: "Таблица доходов",
    zwjy: "Этот друг ещё не торговал, комиссия отсутствует.",
    bczxc: "Сохранить в галерею",
    rlues4: "Из-за сетевых задержек комиссия может зачисляться с задержкой. Пожалуйста, подождите.",
    moreRules: "Подробнее о правилах",
  };


// WEBPACK FOOTER //
// ./src/i18n/lang/merchandiser/ru.js